import { BENEFITS_STATIC } from "@/components/home/benifits/static/benefits.static"
import { useRefCodeStore } from '@/stores/refCodeStore';

const common = [
  {
    path: "/",
    name: "/home",
    component: () => import("@/views/HomePage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "Home" },
    props: () => ({
      benefitsList: BENEFITS_STATIC,
    }),
  },
  {
    path: "/classes/:officeCode?",
    name: "/classes",
    component: () => import("@/views/WorkshopsPage.vue"),
    props: (route) => ({
      page: parseInt(route.query.page) || 1,
      nameMask: route.query.nameMask || null,
      fromAge: route.query.fromAge || null,
      toAge: route.query.toAge || null,
      forWithDisabilities: route.query.forWithDisabilities || -1,
      dateTo: route.query.dateTo || null,
      dateFrom: route.query.dateFrom || null,
      countryIso: route.query.countryIso || null,
    }),
    meta: { requiresAuth: false, layout: "Main", title: "Classes" },
  },
  {
    path: "/programs/:officeCode?",
    name: "/programs",
    component: () => import("@/views/WorkshopsPage.vue"),
    props: (route) => ({
      page: parseInt(route.query.page) || 1,
      nameMask: route.query.nameMask || null,
      fromAge: route.query.fromAge || null,
      toAge: route.query.toAge || null,
      forWithDisabilities: route.query.forWithDisabilities || -1,
      dateTo: route.query.dateTo || null,
      dateFrom: route.query.dateFrom || null,
      countryIso: route.query.countryIso || null,
      refCode: route.query.refCode || null,
    }),
    beforeEnter: (to, from, next) => {
      if (to.query.refCode) {
        const refStore = useRefCodeStore()
        refStore.setRefCode(to.query.refCode)
      }
      next()
    },
    meta: { requiresAuth: false, layout: "Main", title: "Programs" },
  },
  {
    path: "/contacts",
    name: "/contacts",
    component: () => import("@/views/ContactsPage/ContactsPageWrapper.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "Contact us" },
  },
  {
    path: "/partnership",
    name: "/partnership",
    component: () => import("@/views/PartnershipPage/PartnershipPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "Partnership" },
  },
  {
    path: "/franchising",
    name: "/franchising",
    component: () => import("@/views/FranchisingPage/FranchisingPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "Franchising" },
  },
  {
    path: "/email-unsubscribe",
    name: "/email-unsubscribe",
    component: () => import("@/views/EmailUnsubscribePage.vue"),
    meta: {
      requiresAuth: false,
      layout: "PocketHeader",
      title: "Email unsubscribe",
    },
  },
  {
    path: "/investment-deck",
    name: "/investment-deck",
    component: () => import("@/views/InvestmentDeckPage/InvestmentDeckPage.vue"),
    meta: {
      requiresAuth: false,
      layout: "Main",
      title: "Investment Deck",
    },
  },
  {
    path: "/how-it-works",
    name: "/how-it-works",
    component: () => import("@/views/HowItWorksPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "How it works" },
  },
  {
    path: "/sell-on-kids-crafts",
    name: "/sell-on-kids-crafts",
    component: () => import("@/views/SellOnKidsCraftPage.vue"),
    meta: {
      requiresAuth: false,
      layout: "Main",
      title: "Sell On KidsCrafts",
    },
  },
  {
    path: "/about",
    name: "/about",
    component: () => import("@/views/AboutPage/AboutPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "About us" },
  },
  {
    path: "/login",
    name: "/login",
    component: () => import("@/views/LoginPage.vue"),
    meta: { requiresAuth: false, layout: "LoginPage", title: "Login" },
  },
  {
    path: "/for-business",
    name: "/for-business",
    component: () => import("@/views/BusinessPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "For Business" },
  },
  {
    path: "/for-investors",
    name: "/for-investors",
    component: () => import("@/views/InvestorsPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "For Investors" },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
]

export { common }
